<template>
  <v-card class="mx-auto greyBackground" flat>
    <v-card-title class="headline font-weight-regular justify-space-between py-7" >{{ formTitle }}</v-card-title>
    <v-divider class="secondary"></v-divider>
    <v-window v-model="step">
      <v-window-item :value="1">
        <v-card-text>
          <v-form ref="topics" v-model="valid" lazy-validation>
            <v-row>
              <!-- The Topic Name Field -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field v-model="FormTopic.name" solo label="Topic Name" append-icon="icons8-male-user" hide-details="auto" :rules="topicNameRules" required></v-text-field>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3">
                <v-select
                  v-model.trim="FormTopic.status" :items="rangeOfStatus" :menu-props="{ bottom: true, offsetY: true }" solo label="Status" append-icon="icons8-expand-arrow-3" hide-details="auto" :rules="resourceTypeRules" required></v-select>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="3">
                <v-combobox v-model.trim="FormTopic.tags" :items="filterTags" :menu-props="{ bottom: true, offsetY: true }" v-on:keyup.enter="addTagToDB" solo multiple label="Tags" append-icon="icons8-expand-arrow-3" hide-details="auto" :rules="resourceTypeRules" required></v-combobox>
              </v-col>
              <!-- The Description Field -->
              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea v-model="FormTopic.description" solo label="Description" hide-details="auto" :rules="descriptionRules" required></v-textarea>
              </v-col>
              <v-col cols="7" xs="7"  sm="7" md="9">  
                 <v-text-field v-model="FormTopic.buyNowURL" solo label="Buy now URL" append-icon="icons8-link" hide-details="auto"></v-text-field> 
              </v-col>
              <v-col cols="5" xs="5" sm="5" md="3"> 
                <v-btn block height="48" :href="FormTopic.buyNowURL" target="_blank">Test Url</v-btn>
              </v-col>
              <!-- Started Delivery Date-->
              <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :return-value.sync="FormTopic.availableFrom" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="FormTopic.availableFrom" label="Available from" append-icon="mdi-calendar" solo readonly clearable v-on="on" hide-details="auto"></v-text-field>
                  </template>
                  <v-date-picker v-model="FormTopic.availableFrom" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(FormTopic.availableFrom)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <!--Estimate Delivery Date -->
              <v-col cols="12" xs="12" sm="12" md="6" ls="6">
                <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" :return-value.sync="FormTopic.availableTo" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="FormTopic.availableTo" label="Available to" append-icon="mdi-calendar" solo readonly clearable hide-details="auto" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="FormTopic.availableTo" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu2.save(FormTopic.availableTo)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <!-- The Viedo/Image Field -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-card class="mx-auto" max-width="350" height="200" outlined>
                  <!-- Upload Video Component -->
                  <v-card-text class="text-center my-12">
                      <uploadFilesButton  v-if="uploadedFile === null" :storagePath="storagePathProfilePic" :allowedTypes="'video/*'"/>
                    <!-- Show Video after upload -->
                    <p v-else>Uploaded video - {{ uploadedFile.fileName }}</p>
                    <!--/Show Video after upload -->
                  </v-card-text>
                  <!-- /Upload Video Component -->
                </v-card>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-card class="mx-auto align-center justify-center" max-width="350" height="200" outlined>
                  <!-- Upload Image Component -->
                  <v-card-text class="text-center my-12" v-if="uploadedFileImg === null" >
                  <uploadFilesImgButton   :storagePath="storagePathProfilePic" :allowedTypes="'image/*'"/>
                  </v-card-text>
                  <!-- /Upload Image Component -->
                  <!-- Show Image after upload -->
                  <v-img v-else :src="uploadedFileImg.fileURL" contain width="344" height="200"></v-img>
                  <!-- Show Image after upload -->
                </v-card>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="2">
        <v-card-text class="mx-2">
          <v-row>
            <v-col cols="6" class="headline font-weight-regular justify-space-between">ADD RESOURCES</v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn cols="6" color="primary" class="mx-2" fab dark @click=" step++; clearResourcesForm();">ADD</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-data-table :headers="headers" :items="filterNewResources" :search="search" item-key="id" single-select>
                <template v-slot:[`item.accountCreatedAt`]="{ item }">
                  <span class="text-capitalize">{{formatDate(item.accountCreatedAt)}}</span>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-window-item>

      <v-window-item :value="3">
        <v-card-text>
          <v-form ref="resources" v-model="valid" lazy-validation>
            <v-row>
              <!-- The Resource Name Field -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-text-field
                  v-model="FormResources.resourceName"
                   outlined
                class="white"
                  label="Resource Name"
                  hide-details="auto"
                  :rules="resourceNameRules"
                  required
                ></v-text-field>
              </v-col>

              <!-- The Resource Type Field -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-select
                  v-model.trim="FormResources.resourceType"
                  :items="rangeOfTypes"
                  :menu-props="{ bottom: true, offsetY: true }"
                   outlined
                class="white"
                  label="Resource Type"
                  append-icon="icons8-expand-arrow-3"
                  hide-details="auto"
                  :rules="resourceTypeRules"
                  required
                ></v-select>
              </v-col>
              <!--The Resource status Field -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-select
                  v-model.trim="FormResources.status"
                  :items="rangeOfStatus"
                  :menu-props="{ bottom: true, offsetY: true }"
                   outlined
                class="white"
                  label="Status"
                  append-icon="icons8-expand-arrow-3"
                  hide-details="auto"
                  :rules="resourceTypeRules"
                  required
                ></v-select>
              </v-col>
              <!-- Resource Tab Selection -->
              <v-col cols="12" xs="12" sm="12" md="6">
                <v-combobox
                v-model="FormResources.tabSelection"
                :items="filterTabSelection"
                :menu-props="{ bottom: true, offsetY: true }"
                v-on:keyup.enter="addTabSelectionToDB" 
                 outlined
                class="white"
                label="Tab Selection"
                append-icon="icons8-expand-arrow-3"
                hide-details="auto"
                :rules="resourceTypeRules"
                required
              >
              </v-combobox>
              </v-col>
              <!-- The Resource Description Field -->
              <v-col cols="12" xs="12" sm="12" md="12">
                <v-textarea
                  v-model="FormResources.resourceDescription"
                  solo
                  label="Resource Description"
                  hide-details="auto"
                  :rules="resourceDescriptionRules"
                  required
                ></v-textarea>
              </v-col>
              <!-- Started Delivery Date-->
              <v-col cols="12" xs="12" sm="6" md="6" ls="6">
                <v-menu
                  ref="menu3"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :return-value.sync="FormResources.availableFrom"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="FormResources.availableFrom"
                      label="Available from"
                      append-icon="mdi-calendar"
                      solo
                      clearable
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="FormResources.availableFrom"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu3 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu3.save(FormResources.availableFrom)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>

              <!--Estimate Delivery Date -->
              <v-col cols="12" xs="12" sm="6" md="6" ls="6">
                <v-menu
                  ref="menu4"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :return-value.sync="FormResources.availableTo"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="FormResources.availableTo"
                      label="Available to"
                      append-icon="mdi-calendar"
                      solo
                      readonly
                      clearable
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="FormResources.availableTo"
                    no-title
                    scrollable
                  >
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu4 = false"
                      >Cancel</v-btn
                    >
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.menu4.save(FormResources.availableTo)"
                      >OK</v-btn
                    >
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" xs="12" sm="12" md="12">
                <v-card
                  class="mx-auto align-center justify-center"
                  max-width="100%"
                  height="200"
                  outlined
                  v-if="FormResources.resourceType != 'html' && FormResources.resourceType != 'link'"

                >
                  <!-- Upload Resource Component -->
                  <v-card-text class="text-center my-12">
                    <uploadFilesResourceButton  v-if="uploadedFileResource === null" :storagePath="storagePathProfilePic" :allowedTypes="allowedTypes"/>
                    <!-- Show Resource after upload -->
                    <p v-else>
                      Uploaded resource -
                      {{ uploadedFileResource.fileName }}
                    </p>
                  </v-card-text>
                  <!-- /Upload Resource Component -->
                </v-card>
                <!--/Show Resource after upload -->
              </v-col>

              <!-- The Marketing checkbox -->
              <v-col cols="12" class="my-0 py-0">
                <v-checkbox
                  v-model="FormResources.downloadable"
                  class="mx-2"
                  label="Downloadable"
                  hide-details="auto"
                ></v-checkbox>
                <p
                  class="caption grey--text text--darken-1 pa-1"
                  style="text-align: justify !important"
                >
                  By checking this box you are making this resource available for download for any user that will have access to this topic.
                </p>
              </v-col>
            </v-row>
          </v-form>
          <v-btn
            v-if="step === 3"
            class="px-8"
            color="primary"
            depressed
            @click="saveResources()"
            v-on:keyup.enter="saveResources()"
            >UPLOAD</v-btn
          >
        </v-card-text>
      </v-window-item>
    </v-window>
    <v-divider class="grey"></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="primary"
        v-if="step === 2"
        class="px-8"
        v-on:click="closeTopic()"
      >
        <v-icon size="13" left>icons8-delete</v-icon>CANCEL
      </v-btn>
      <v-btn
        v-if="step === 3"
        class="mx-2"
        dark
        color="primary"
        @click="step--"
      >
        BACK
      </v-btn>
      <v-btn
        v-if="step === 1"
        class="px-8"
        color="primary"
        depressed
        @click="saveTopic()"
        v-on:keyup.enter="saveTopic()"
        >ΑDD TOPIC</v-btn
      >
      <v-btn
        v-if="step === 2"
        class="px-8"
        color="primary"
        depressed
        v-on:click="closeTopic()"
        >FINISHED</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import FilestackUpload from "../page-components/FilestackUpload.vue";
import { mapGetters, mapState, mapActions  } from 'vuex'; // Map the Getters from the Vuex Store



export default {
  name: "AddTopic",
  components: {
    FilestackUpload,
  },
  props: {
    filestackAPI: {
      type: Array,
      required: true,
    },
    resourceList: {
      type: Array,
      required: true,
    },
    changeWindowsFlag: {
      type: Boolean, //open invite user window
      required: true,
    },
  },
  data: () => ({
    step: 1,
    valid: true,
    rangeOfTypes: ["pdf", "html", "image", "video", "link"],
    rangeOfStatus: ["Draft", "Published"],
    tagsList: [],
    tabsSelectionList:[],
    search: "",
    // DOCUMENT UPLOAD
     isUploading: false, //upload progress bar
     allowedTypes: "image/*, video/*, audio/*, text/*, .pdf, .PPT, .ppt, .PPTX, .pptx, .docx, .doc, .xls, .xlsx, .csv" ,
     folder: '',
    storagePathProfilePic: 'topics',
    // the topic form
    FormTopic: {
      id: "",
      name: "",
      description: "",
      videoURL: "",
      photoURL: "",
      buyNowURL: "",
      status: "",
      fileData: null,
      tags: [],
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },
    //resource form
    FormResources: {
      fileData: null,
      resourceName: "",
      resourceType: "",
      resourceDescription: "",
      downloadable: false,
      tabSelection: "",
      url: "",
      type:"",
      topicId: "",
      status: "",
      availableFrom: "",
      availableTo: "",
      createdBy: "",
      modifiedBy: "",
      createdTimestamp: "",
      modifiedTimestamp: "",
    },
    headers: [
      {
        text: " Name",
        align: "start",
        filterable: false,
        value: "resourceName",
      },
      { text: "Type", value: "resourceType" },
      //{ text: "Description", value: "resourceDescription" },
      { text: "Downloadable", value: "downloadable" },
      { text: "Status", value: "status" },
      { text: "Available From", value: "availableFrom" },
      { text: "Available To", value: "availableTo" },
      { text: "Created at", value: "accountCreatedAt" },

      {
        text: "Actions",
        value: "actions",
        sortable: false,
        hidden: false,
        align: "end",
      },
    ],
    addResourceFlag: false, //just added

    //filestack integration
    uploadResultImage: "Nothing", // image upload holder
    uploadResultVideo: "Nothing", // video upload holder
    uploadResultResource: "Nothing", // resource upload holder

    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,

    topicNameRules: [(v) => !!v || "Full topic name is required"],
    descriptionRules: [(v) => !!v || "Some description is required"],
    resourceNameRules: [(v) => !!v || "Full Resource name is required"],
    resourceTypeRules: [(v) => !!v || "The Resource type is required"],
    resourceDescriptionRules: [
      (v) => !!v || "Some description of the topic is required",
    ],
  }),
  computed: {
     ...mapState({
                uploadedFile: (state) => state.upload_file_store.file,
                uploadedFileImg: (state) => state.upload_file_img_store.file,
                uploadedFileResource: (state) => state.upload_file_resource_store.file
            }),
    
    filterNewResources() {
      //console.log("hi" + id);
      var self = this;
      var newReourcesArray = this.resourceList.filter(function(item) {
        //  console.log("hi 2 "+ item.topicId);
        return self.FormTopic.id === item.topicId;
      });
      return newReourcesArray;
    },
    formTitle() {
      if (this.step === 1) {
        return "ADD NEW TOPIC";
      } else if (this.step === 2) {
        return "TOPIC " + this.FormTopic.name + " HAS BEEN ADDED";
      } else {
        return "NEW RESOURCE FOR " + this.FormTopic.name;
      }
    },
     filterTags(){
      var objTags = [];
      for(var i=0; i< this.tagsList.length; i++){
        objTags.push(this.tagsList[i].name);
      }
      return objTags;
    },
    filterTabSelection(){
      var objTabs = [];
      for(var i=0; i< this.tabsSelectionList.length; i++){
        objTabs.push(this.tabsSelectionList[i].name);
      }
      return objTabs;
    },
     // DOC LINK (GENERIC) - REQUIRED FOR DOCUMENT UPLOAD
            docLink() {
                var t = this;
                return ({ collection: 'resources', documentId: t.FormTopic.id })
            }
  },
  watch: {
     uploadedFile: {
                handler: function() {
                    this.uploadedFile;
                },
                deep: true
            },
     uploadedFileImg: {
                handler: function() {
                    this.uploadedFileImg;
                },
                deep: true
            },
      uploadedFileResource: {
                handler: function() {
                    this.uploadedFileResource;
                },
                deep: true
            },    
    uploadResultImage() {
      this.FormTopic.photoURL = this.uploadResultImage[0].url;
    },
    uploadResultVideo() {
      this.FormTopic.videoURL = this.uploadResultVideo[0].url;
    },
    uploadResultResource() {
      this.FormResources.url = this.uploadResultResource[0].url;
    },
  },
  methods: {
    isVideo(fileType) {
      switch (fileType) {
        case 'video/m4v':
        case 'video/avi':
        case 'video/mpg':
        case 'video/mp4':
          return true;
      }
      return false;
    },
    isImage(fileType) {
      switch (fileType) {
        case 'image/jpg':
        case 'image/gif':
        case 'image/bmp':
        case 'image/png':
        case 'image/jpeg':
          //etc
          return true;
      }
      return false;
    },
     
    //add/udate the tags on the list and db
    addTagToDB(){
        var self = this;
      for(var i =0; i < self.FormTopic.tags.length; i++){
        if( !this.filterTags.includes(self.FormTopic.tags[i])){ 
           var form = {name:self.FormTopic.tags[i]};
             self.$firebase.db
          .collection("tags")
          .doc()
          .set(form)
          .then((docRef) => {})
          .catch((error) => {
         //   console.log("Error adding document: ", error);
          });
        self.tagsList.push(form)
        }
      }
    },
    //method to retrieve the tags from the db
    readTagsFromDB(){
      var self = this;
      this.$firebase.db
        .collection("tags")
        .onSnapshot((querySnapshot) => {
          self.tagsList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.tagsList.push(Data);
          });
        });
    },
     //add/udate the tabs on the list and db
    addTabSelectionToDB(){
        var self = this;
        if( !this.filterTabSelection.includes(self.FormResources.tabSelection)){ 
           var form = {name:self.FormResources.tabSelection};
             self.$firebase.db
          .collection("tabs")
          .doc()
          .set(form)
          .then((docRef) => {})
          .catch((error) => {
         //   console.log("Error adding document: ", error);
          });
        self.tabsSelectionList.push(form)
        
      }
    },
    //method to retrieve the tabs from the db
    readTabsSelectionFromDB(){
      var self = this;
      this.$firebase.db
        .collection("tabs")
        .onSnapshot((querySnapshot) => {
          self.tagsList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.tabsSelectionList.push(Data);
          });
        });
    },
    clearResourcesForm() {
      this.FormResources.resourceName = "";
      this.FormResources.resourceDescription = "";
      this.FormResources.resourceType = "";
      this.FormResources.url = "";
      this.FormResources.tabSelection="",
      this.FormResources.topicId = "";
      this.FormResources.downloadable = false;
      this.FormResources.status = "";
      this.FormResources.availableFrom = "";
      this.FormResources.availableTo = "";
      this.FormResources.modifiedBy = "";
      this.FormResources.modifiedTimestamp = "";
      this.FormResources.createdBy = "";
      this.FormResources.createdTimestamp = "";
      this.$store.commit("upload_file_resource_store/setFile", null);
      this.FormResources.type ="";

    },
    formatDate(date) {
      date = this.$moment(date).format("DD MMM YYYY");
      return date;
    },
    uuidv4() {
      return "xxxxxxxx-xxxx-yxxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
        c
      ) {
        var r = (Math.random() * 16) | 0,
          v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
    },
    saveTopic() {
      if (this.$refs.topics.validate()) {        
        if( this.uploadedFile != null && this.isVideo(this.uploadedFile.fileType)){
          this.FormTopic.videoURL = this.uploadedFile.fileURL;         
        } 
        if ( this.uploadedFileImg != null && this.isImage(this.uploadedFileImg.fileType)){
           this.FormTopic.photoURL = this.uploadedFileImg.fileURL;
        }

        var self = this;
        this.FormTopic.createdTimestamp = this.$moment().toISOString();
        this.FormTopic.createdBy = this.$store.getters.currUser.id;
        this.FormTopic.id = this.uuidv4();
        self.$firebase.db
          .collection("topics")
          .doc(self.FormTopic.id)
          .set(self.FormTopic)
          .then((Result) => {})
          .catch((err) => {
            //console.log(err);
          });

        this.step++;
      } else {
       // console.log("not valid");
        this.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    saveResources() {
      var self = this;
      if (this.$refs.resources.validate()) {
        self.FormResources.createdTimestamp = self.$moment().toISOString();
        self.FormResources.createdBy = self.$store.getters.currUser.id;
        self.FormResources.topicId = self.FormTopic.id;
        if(self.uploadedFileResource != null){
        self.FormResources.url = self.uploadedFileResource.fileURL;
        self.FormResources.type = self.uploadedFileResource.fileType;
        }
        self.$firebase.db
          .collection("resources")
          .doc()
          .set(self.FormResources)
          .then((docRef) => {
            self.$snotify.info("The resource was created.");
          })
          .catch((err) => {
           // console.log("Error adding document: ", error);
            self.$snotify.error(error);
          });
        self.step--;
      } else {
       // console.log("not valid");
        self.$snotify.error(
          "Fill out all the fields correctly in order to proceed."
        );
      }
    },
    closeTopic() {
      this.$emit("close-topic");
    },
  },
  created(){
    this.readTagsFromDB();
    this.readTabsSelectionFromDB();
  },
  mounted(){
      this.$store.commit("upload_file_store/setFile", null); 
      this.$store.commit("upload_file_img_store/setFile", null);
      this.$store.commit("upload_file_resource_store/setFile", null);

  }
};
</script>
